import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AccountBreadcrumb } from '../../../../../../../../features/registration/account/account-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/dividends-receivable/_dividends-receivable')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `dividends-receivable-layout-account-${params.accountId}`,
        label: <AccountBreadcrumb accountId={params.accountId} displayIdOnly />,
        to: `/registration/account/${params.accountId}/asset`,
      }),
    }) satisfies AggregateBreadcrumb,
});
